import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
    Arrays,
    SubscriptionPeriodUnit,
    SubscriptionPeriodUnitUtils,
    SubscriptionPlanType,
    SubscriptionPlanTypeUtils,
    SubscriptionSource,
    SubscriptionSourceUtils,
    Title
} from 'common';
import {AdminReportGroupFilter} from '../../viewmodels/adminReportGroupFilter';
import {BaseComponent} from '../base.component';

@Component({
    selector: 'app-admin-report-filters',
    templateUrl: './admin-report-filters.component.html',
    styleUrls: ['./admin-report-filters.component.scss']
})
export class AdminReportFiltersComponent extends BaseComponent implements OnInit {
    @Input()
    public showFilters: boolean;

    @Input()
    public showSearch: boolean;

    @Input()
    public searchLabel: string;

    @Input()
    public filter: AdminReportGroupFilter;

    @Output()
    public filterChanged: EventEmitter<AdminReportGroupFilter>;

    public subscriptionPlanType: Map<SubscriptionPlanType, Title>;
    public subscriptionPeriodUnit: Map<SubscriptionPeriodUnit, Title>;
    public subscriptionSource: Map<SubscriptionSource, Title>;

    constructor() {
        super();
        this.filterChanged = new EventEmitter<AdminReportGroupFilter>();
        this.subscriptionPlanType = new Map<SubscriptionPlanType, Title>();
        this.subscriptionPeriodUnit = new Map<SubscriptionPeriodUnit, Title>();
        this.subscriptionSource = new Map<SubscriptionSource, Title>();
    }

    ngOnInit(): void {
        for (const type of SubscriptionPlanTypeUtils.getAll()) {
            this.subscriptionPlanType.set(type, SubscriptionPlanTypeUtils.title(type));
        }

        for (const type of SubscriptionPeriodUnitUtils.getAll()) {
            if (type === SubscriptionPeriodUnit.CUSTOM && this.filter.supportSubscriptionCustomPeriodUnit === false) {
                continue;
            }
            this.subscriptionPeriodUnit.set(type, SubscriptionPeriodUnitUtils.title(type));
        }

        for (const type of SubscriptionSourceUtils.getAll()) {
            if (type === SubscriptionSource.CLOUD_ADMIN && this.filter.supportsCloudAdminSubscriptionSource === false) {
                continue;
            }
            this.subscriptionSource.set(type, SubscriptionSourceUtils.title(type));
        }
    }

    public onQueryChange(event: string): void {
        this.filter.query = event;
        this.filterChanged.emit(this.filter);
    }

    public onSubscriptionPlanTypeClick(type: SubscriptionPlanType): void {
        if (this.filter.subscriptionPlanTypes.includes(type)) {
            Arrays.toggleValue(this.filter.subscriptionPlanTypes, type);
        } else {
            this.filter.subscriptionPlanTypes.push(type);
        }
        this.filterChanged.emit(this.filter);
    }

    public onSubscriptionSourceClick(type: SubscriptionSource): void {
        if (this.filter.subscriptionSources.includes(type)) {
            Arrays.toggleValue(this.filter.subscriptionSources, type);
        } else {
            this.filter.subscriptionSources.push(type);
        }
        this.filterChanged.emit(this.filter);
    }

    public onApplyRenewedClick(checked: boolean): void {
        this.filter.applyRenewable = checked;
        this.filterChanged.emit(this.filter);
    }

    public onApplyActiveClick(checked: boolean): void {
        this.filter.applyActive = checked;
        this.filterChanged.emit(this.filter);
    }

    public onRenewedClick(checked: boolean): void {
        this.filter.renewable = checked;
        this.filterChanged.emit(this.filter);
    }

    public onActiveClick(type: boolean): void {
        this.filter.active = type;
        this.filterChanged.emit(this.filter);
    }

    public onSubscriptionPeriodUnitClick(type: SubscriptionPeriodUnit): void {
        if (this.filter.subscriptionPeriodUnits.includes(type)) {
            Arrays.toggleValue(this.filter.subscriptionPeriodUnits, type);
        } else {
            this.filter.subscriptionPeriodUnits.push(type);
        }
        this.filterChanged.emit(this.filter);
    }
}
